import React, {
  forwardRef,
  memo,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from 'react'
import { Input, InputNumber } from 'antd'
import { CellBox } from 'Components/DossierUnico/DossierUnicoData'

const AgNumberCellEditor = memo(
  forwardRef((props, ref) => {
    const { value: initialValue, colDef, stopEditing } = props
    const { cellEditorParams } = colDef
    const [value, setValue] = useState(initialValue)
    const refInput = useRef(null)

    useEffect(() => {
      refInput.current.focus()
    }, [])

    useImperativeHandle(ref, () => {
      return {
        getValue() {
          return value
        },
        isCancelBeforeStart() {
          return cellEditorParams?.isCancelBeforeStart?.(props) ?? false
        },
        isCancelAfterEnd() {
          return cellEditorParams?.isCancelAfterEnd?.(props) ?? false
        },
      }
    })

    return (
      <CellBox>
        <InputNumber
          onChange={setValue}
          value={value}
          ref={refInput}
          style={{ width: '100%' }}
          onBlur={() => stopEditing?.()}
        />
      </CellBox>
    )
  }),
)

export default AgNumberCellEditor;
